import React from 'react';
import { Sparkles } from 'lucide-react';
import useAuth from './hooks/useAuth';
import LoginPage from './components/auth/LoginPage';
import DocumentationPage from './pages/DocumentationPage';

// App Component
export default function App() {
  const { user, loading, signInWithGoogle, signOut } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 flex items-center justify-center">
        <div className="relative">
          <div className="absolute inset-0 bg-gradient-to-r from-purple-400 to-blue-400 rounded-full blur-lg opacity-75 animate-pulse"></div>
          <div className="relative bg-gradient-to-r from-purple-500 to-blue-500 rounded-full p-4">
            <Sparkles className="w-8 h-8 text-white animate-spin" />
          </div>
        </div>
      </div>
    );
  }

  return user ? (
    <DocumentationPage user={user} onLogout={signOut} />
  ) : (
    <LoginPage onLogin={signInWithGoogle} />
  );
}
